module.exports = __webpack_public_path__ + "img/pause-button-blue.4639a003.svg";